<template>
  <div @mouseenter="isTaskOptionsButtonShown = true" @mouseleave="isTaskOptionsButtonShown = false">
    <b-row>
      <b-col class="col-1 mt-3 center-align-icon">
        <font-awesome-icon v-if="!taskDetails.completed" class="task-completed-toggle" :icon="['far', 'circle']"
                           @click="toggleTaskCompleted"/>
        <font-awesome-icon v-else class="task-completed-toggle" :icon="['fas', 'check-circle']"
                           @click="toggleTaskCompleted"/>
      </b-col>
      <b-col class="task-details-click-area" @click="showTaskDetailsModal">
        <p class="task-name-text" :class="{'completed-task-text': taskDetails.completed}">{{ taskDetails.taskName }}</p>
        <p v-if="taskDetails.assigneeName" class="task-description-text" :class="{'completed-task-assignee': taskDetails.completed}">Assignee: {{ taskDetails.assigneeName }}</p>
        <p v-else class="task-description-text" :class="{'completed-task-assignee': taskDetails.completed}">Assignee: Unassigned</p>
      </b-col>
      <b-col class="col-1 mt-3 center-align-icon">
        <font-awesome-icon v-if="taskDetails.priority === 0" class="task-priority-icon" icon="exclamation"
                           @click="showTaskDetailsModal"/>
        <font-awesome-icon v-else-if="taskDetails.priority === 2" class="task-priority-icon" icon="arrow-down"
                           @click="showTaskDetailsModal"/>
      </b-col>
      <b-col v-if="isCollaborativeListAdministrator" class="col-1 mr-4 center-align-icon">
        <font-awesome-icon v-if="isTaskOptionsButtonShown" class="task-option-button mt-1" :icon="['far', 'edit']"
                           @click="showTaskDetailsModal"/>
        <font-awesome-icon v-if="isTaskOptionsButtonShown" class="task-option-button mt-3" :icon="['far', 'trash-alt']"
                           @click="isDeleteTaskModalShown = true"/>
      </b-col>
    </b-row>
    <hr>

    <!-- Task Details Modal -->
    <b-modal
        id="task-details-modal"
        :title="taskDetailsModalTitle"
        :visible="isTaskDetailsModalShown"
        @hide="isTaskDetailsModalShown = false"
        scrollable
        no-close-on-backdrop
        hide-footer>
      <collaborative-task-details v-if="taskDetails.taskType === 'Collaborative Task'"
                                  :collaborative-task-details="taskDetails"></collaborative-task-details>
    </b-modal>

    <!-- Task Options Modal -->
    <b-modal
        id="delete-task-modal"
        title="Delete Task"
        :visible="isDeleteTaskModalShown"
        @hide="isDeleteTaskModalShown = false"
        @ok="deleteTask(taskDetails.taskId)"
        scrollable
        ok-only
        ok-title="Delete task"
        ok-variant="danger"
        no-close-on-backdrop>
      <p class="delete-task-text">Are you sure do you want to delete <strong>"{{ taskDetails.taskName }}"</strong> from
        the list?</p>
    </b-modal>
  </div>
</template>

<script>
  import CollaborativeTaskDetails from "../../task_details_templates/CollaborativeTaskDetails"
  import {mapGetters} from "vuex";
  import {db, storage} from "../../../main";

  export default {
    name: "RegularWithAssigneeTaskCell.vue",
    props: {
      taskDetails: Object
    },
    components: {
      collaborativeTaskDetails: CollaborativeTaskDetails
    },
    data() {
      return {
        isTaskOptionsButtonShown: false,
        isTaskDetailsModalShown: false,
        taskDetailsModalTitle: '',
        isDeleteTaskModalShown: false,
        isUndoTaskDeletionClicked: false
      }
    },
    methods: {
      deleteTask(taskId) {
        db
          .collection('collaborative_to_do_lists/' + this.taskDetails.toDoListId + '/tasks')
          .doc(taskId)
          .get()
          .then(doc => {
            // pass the image object for image deletion operation
            const attachmentObject = doc.data().attachment
            this.openTaskDeletionToast(attachmentObject)

            // delete the actual task
            doc.ref.delete()
          })
      },
      undoTaskDeletion() {
        this.isUndoTaskDeletionClicked = true

        this.$snack.show({
          text: '\"' + this.taskDetails.taskName + '\" has been re-added to the list',
          button: null,
          action: null
        })

        // recover the recently deleted task with updated taskId
        db
          .collection('collaborative_to_do_lists/' + this.taskDetails.toDoListId + '/tasks')
          .add(this.taskDetails)
          .then(docRef => {
            const taskId = docRef.id
            db.collection('collaborative_to_do_lists/' + this.taskDetails.toDoListId + '/tasks')
              .doc(taskId)
              .update('taskId', taskId)
          })
      },
      openTaskDeletionToast(attachmentObject) {
        this.isUndoTaskDeletionClicked = false

        this.$snack.show({
          text: '\"' + this.taskDetails.taskName + '\" has been deleted',
          button: 'UNDO',
          action: this.undoTaskDeletion
        })

        setTimeout(() => {
          if (!this.isUndoTaskDeletionClicked) {
            if (attachmentObject !== null) {
              const attachment = attachmentObject.toString()
              const attachmentRef = storage.refFromURL(attachment)

              attachmentRef.delete()

              // reset the undo task deletion clicked state
              this.isUndoTaskDeletionClicked = false
            }
          }
        }, 7500)
      },
      showTaskDetailsModal() {
        this.isTaskDetailsModalShown = true
        this.taskDetailsModalTitle = 'Collaborative Task Details'
      },
      toggleTaskCompleted() {
        const assigneeId = this.taskDetails.assigneeId;
        const isAdministrator = this.$store.getters.isCollaborativeListAdministrator;

        // check if the user is allowed to change task completion status
        if ((assigneeId == null && isAdministrator) || (assigneeId != null && assigneeId === this.$store.getters.user.data.id) || isAdministrator) {

          const updatedStatus = !this.taskDetails.completed

          // safeguard to ensure that the document has an id to be referred to
          if (this.taskDetails.taskId === null) {
            db.collection('collaborative_to_do_lists/' + this.taskDetails.toDoListId + '/tasks')
              .doc(this.taskDetails.id)
              .update('taskId', this.taskDetails.id)
          }

          db.collection('collaborative_to_do_lists/' + this.taskDetails.toDoListId + '/tasks')
            .doc(this.taskDetails.id)
            .update('completed', updatedStatus)
        } else {
          this.rejectToggleTaskCompletedToast()
        }
      },
      rejectToggleTaskCompletedToast() {
        this.$bvToast.toast('As a member, you are not allowed to modify other collaborator\'s task', {
          title: 'Cannot toggle task completion status',
          toaster: 'b-toaster-top-right',
          solid: true,
          appendToast: false
        })
      }
    },
    computed: {
      ...mapGetters([
        "isCollaborativeListAdministrator"
      ])
    },
  }
</script>

<style scoped>
  .center-align-icon {
    text-align: center;
  }

  .task-completed-toggle {
    font-size: 1.5em;
  }

  .task-completed-toggle:hover {
    cursor: pointer;
  }

  .completed-task-text {
    text-decoration: line-through;
    color: gray;
  }

  .completed-task-assignee {
    color: gray;
  }

  .task-priority-icon {
    font-size: 1.5em;
  }

  .task-name-text {
    margin-bottom: 0.5em;
  }

  .task-description-text {
    font-size: 0.9em;
    margin-bottom: 0;
  }

  .task-details-click-area {
    cursor: pointer;
  }

  .task-option-button {
    display: block;
  }

  .task-option-button:hover {
    cursor: pointer;
  }
</style>
